import React, { useEffect, useMemo } from 'react';

import HeroBanner from './hero-banner';
import HomeTiles from './home-tiles';


const HomePage = () => {
    return <div className={'home'}>
        <HeroBanner />
        <HomeTiles />
    </div>;
}

export default HomePage;